import { MultiSelectDropdown } from "@monsterindia/global-ui-components";
import React, { memo } from "react";
import { Controller } from "react-hook-form";

import {
  DropdownOptionType,
  MultiDropDownControllerProps,
} from "../dropdownController.types";

const MultiDropDownController = ({
  name,
  control,
  options,
  onSelect,
  onChangeHandler,
  placeholder,
  errorMessage,
  maxSelect,
  isDisabled,
  isRequired = true,
  isSearchable,
  isLoading,
}: MultiDropDownControllerProps) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={isRequired ? { required: "This field is required" } : undefined}
      render={({ field }) => {
        return (
          <MultiSelectDropdown
            {...field}
            id={name}
            width="!l1-w-full"
            options={options ?? []}
            className="!l1-flex !l1-w-full !l1-flex-row"
            loadingText={isLoading ? "Loading..." : "No options available"}
            placeholder={placeholder}
            onChangeHandler={onChangeHandler}
            isSearchable={isSearchable ?? false}
            maxSelect={maxSelect}
            selectedValues={field.value ?? []}
            handleDropdownSelect={(selected: DropdownOptionType) => {
              field.onChange(selected);
              onSelect(selected);
            }}
            disabled={isDisabled}
            errorText={errorMessage}
          />
        );
      }}
    />
  );
};

export default memo(MultiDropDownController);
